import React, { useState } from 'react';

const GLOBAL_TEE_PENALTY_DEFAULTS = [
  {tee:1,score:0.0150},{tee:2,score:2.0427},{tee:3,score:4.0732},{tee:4,score:4.1463},
  {tee:5,score:5.0000},{tee:6,score:3.9024},{tee:7,score:2.5061},{tee:8,score:5.0000},
  {tee:9,score:2.2134},{tee:10,score:0.0170},{tee:11,score:2.4024},{tee:12,score:1.8780},
  {tee:13,score:3.4390},{tee:14,score:0.0400},{tee:15,score:3.2134},{tee:16,score:4.3841},
  {tee:17,score:2.7805},{tee:18,score:3.5183},{tee:19,score:0.0315},{tee:0,score:5},
];

function TeePenaltyTable({ value, onChange, defaults }) {
  const [editingIdx, setEditingIdx] = useState(null);
  const [editValue, setEditValue] = useState('');

  const overrides = value || [];
  const sortedDefaults = [...defaults].sort((a, b) => a.tee - b.tee);

  const startEdit = (idx) => {
    setEditingIdx(idx);
    setEditValue(String(overrides[idx].score));
  };

  const saveEdit = (idx) => {
    const newScore = parseFloat(editValue);
    if (isNaN(newScore) || newScore < 0) {
      setEditingIdx(null);
      return;
    }
    const updated = [...overrides];
    updated[idx] = { tee: updated[idx].tee, score: Math.round(newScore * 10000) / 10000 };
    onChange(updated);
    setEditingIdx(null);
  };

  const cancelEdit = () => setEditingIdx(null);

  const removeOverride = (overrideIdx) => {
    onChange(overrides.filter((item, i) => i !== overrideIdx));
  };

  const createOverride = (tee) => {
    const defaultEntry = sortedDefaults.find((d) => d.tee === tee);
    const newOverride = { tee: tee, score: defaultEntry ? defaultEntry.score : 2.5 };
    const newArrIdx = overrides.length;
    onChange([...overrides, newOverride]);
    setEditingIdx(newArrIdx);
    setEditValue(String(newOverride.score));
  };

  const resetToDefaults = () => {
    onChange([]);
  };

  const getOverrideIdx = (tee) => overrides.findIndex((o) => o.tee === tee);

  const renderRows = () => {
    return sortedDefaults.map((defaultEntry) => {
      const overrideIdx = getOverrideIdx(defaultEntry.tee);
      const isUserOverride = overrideIdx !== -1;
      const displayScore = isUserOverride ? overrides[overrideIdx].score : defaultEntry.score;
      const isEditing = editingIdx === overrideIdx && isUserOverride;

      return (
        <tr key={defaultEntry.tee} className={isUserOverride ? 'table-warning' : ''}>
          <td>Tee {defaultEntry.tee}</td>
          <td>
            {isEditing ? (
              <input
                type="number"
                step="0.0001"
                min="0"
                className="form-control form-control-sm d-inline-block"
                style={{ width: 90 }}
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') saveEdit(overrideIdx);
                  if (e.key === 'Escape') cancelEdit();
                }}
                autoFocus
              />
            ) : (
              <span>{displayScore.toFixed(4)}</span>
            )}
          </td>
          <td>
            <small className={isUserOverride ? 'text-warning fw-bold' : 'text-muted'}>
              {isUserOverride ? 'Override' : 'Default'}
            </small>
          </td>
          <td>
            {isUserOverride ? (
              <div className="d-flex gap-1">
                {!isEditing ? (
                  <button type="button" className="btn btn-sm btn-outline-warning" onClick={() => startEdit(overrideIdx)}>Edit</button>
                ) : (
                  <span>
                    <button type="button" className="btn btn-sm btn-success" onClick={() => saveEdit(overrideIdx)}>&#10003;</button>
                    <button type="button" className="btn btn-outline-secondary" onClick={cancelEdit}>x</button>
                  </span>
                )}
                <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => removeOverride(overrideIdx)}>Reset</button>
              </div>
            ) : (
              <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => createOverride(defaultEntry.tee)}>Override</button>
            )}
          </td>
        </tr>
      );
    });
  };

  return (
    <div className="tee-penalty-table">
      <table className="table table-sm table-hover">
        <thead>
          <tr>
            <th scope="col">Tee</th>
            <th scope="col">Score</th>
            <th scope="col">Source</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {renderRows()}
        </tbody>
      </table>
      <div className="mt-2 d-flex gap-2 flex-wrap">
        <button type="button" className="btn btn-sm btn-outline-danger" onClick={resetToDefaults}>Reset All to Defaults</button>
      </div>
    </div>
  );
}

export { TeePenaltyTable, GLOBAL_TEE_PENALTY_DEFAULTS };
